import VouchersImportExport from './VouchersImportExport';

export default VouchersImportExport;


// WEBPACK FOOTER //
// ./src/scenes/VouchersImportExport/index.tsx